export class AdditionalAddressLines {
    constructor() {
        this.additionalAddressLines = false;
        this.addressLine1 = null;
        this.addressLine2 = null;
    }
}
